import { useAppState } from "../../context";
import { ProductType } from "../../types";
import { fetchJson } from "../../utils";

export const useProducts = () => {
    const [productCache, setProductCache] = useAppState<Map<number, ProductType>>('product-cache', new Map());

    const findProducts = async (ids: number[]): Promise<ProductType[]> => {
        const { missing, products } = ids.reduce((acc, id) => {
            if (!productCache.has(id)) {
                acc.missing.push(id);
            } else {
                acc.products.push(productCache.get(id) as ProductType);
            }
            return acc;
        }, {
            products: [] as ProductType[],
            missing: [] as number[]
        });

        if (missing.length === 0) {
            return products;
        }

        let retryCount = 0;
        let currentMissing = [...missing];
        
        while (currentMissing.length > 0 && retryCount < 3) {
            try {
                const { json } = await fetchJson<{ data: ProductType[] }>(`/api/catalog?_filter=${JSON.stringify({
                    id: currentMissing
                })}`);
                products.push(...json.data);
                currentMissing = currentMissing.filter(id => 
                    !json.data.some(product => product.id === id)
                );

                const newCache = new Map(productCache);
                json.data.forEach(p => {
                    newCache.set(p.id, p);
                });
                setProductCache(newCache);
            } catch (error) {
                console.error(`Retry ${retryCount + 1} failed:`, error);
            }
            retryCount++;
        }

        return products;
    };

    return { findProducts };
}; 